<div class="nova__dialog__toolbar">
    <div class="nova__dialog__toolbar__title--lg">Select Candidate</div>
    <button mat-icon-button mat-dialog-close tabindex="-1" class="close-modal">
        <mat-icon>close</mat-icon>
    </button>
</div>

<div class="dialog">
    <form class="form">
        <mat-form-field appearance="outline" class="form-field" subscriptSizing="dynamic">
            <input matInput [formControl]="candidateSearchInput"
                type="text"
                placeholder="Candidate name, email, or phone"
                [hidden]="isCandidateSelected()"
                [matAutocomplete]="candidateAuto"
                data-qa-id="CandidateSearchInput">

            @if (isCandidateSelected()) {
                <div contenteditable="false" data-qa-id="CandidateSearchInput">
                    <span class="candidate-display-name">{{ selectedCandidate()?.fullName }}</span>
                    <span class="candidate-display-recruiter">Recruiter: {{ selectedCandidate()?.recruiterFullName }}</span>
                </div>
            }

            <mat-autocomplete #candidateAuto="matAutocomplete" [displayWith]="candidateNameDisplay"
                (optionSelected)="candidateSelected($event)">
                @for (candidate of candidates() | orderBy: 'fullName'; track candidate.id) {
                    <mat-option [value]="candidate">
                        <span class="candidate-name">{{candidate.fullName}}</span>
                        <span class="recruiter-name">Recruiter: {{candidate.recruiterFullName}}</span>
                    </mat-option>
                }
            </mat-autocomplete>
            @if (!isCandidateSelected()) {
                <mat-hint class="muted-text muted-text--smaller-font">Provider must have a valid NPI to create a margin.</mat-hint>
            }
            @if (!isCandidateSelected()) {
                <button class="non-clickable" disabled>
                    <mat-icon class="pending-selection-icon">search</mat-icon>
                </button>
            } @else {
                <button mat-icon-button class="clear-selection-btn" (click)="resetCandidateSelection()">
                    <mat-icon>close</mat-icon>
                </button>
            }

            @if (candidateSearchInput.hasError('missingNPI')) {
                <mat-error data-qa-id="MissingNPIMessageError">Locums provider has a missing NPI#</mat-error>
            }

        </mat-form-field>
    </form>

    <button mat-dialog-close color="primary"
        (click)="onContinue()"
        [disabled]="!isCandidateSelected() || candidateSearchInput.invalid"
        class="continue-button"
        [class.continue-button--disabled]="!isCandidateSelected() || candidateSearchInput.invalid"
        [class.continue-button--enabled]="isCandidateSelected() && candidateSearchInput.valid"
        data-qa-id="CandidateSearchContinueButton"
        matRipple>
        <span matTooltip="Please select a candidate" [matTooltipDisabled]="isCandidateSelected()">CONTINUE</span>
    </button>
    @if (isCandidateSelected() && candidateSearchInput.invalid) {
        <button mat-flat-button
            class="mat-raised-button"
            id="view-profile-button"
            data-qa-id="CandidateSearchViewProfileButton"
            (click)="openCandidatePage()">
            VIEW PROFILE
        </button>
    }
    <button mat-flat-button mat-dialog-close class="cancel-button" data-qa-id="CandidateSearchCancelButton">
        CANCEL
    </button>
</div>
